export const EnumValueFromIndex = (enumerate: any, index: number): any => {
    return Object.values(enumerate).at(index)
}

export const EnumValueToIndex = (enumerate: any, value: any): number => {
    return Object.values(enumerate).indexOf(value)
}
